export const CacheHeaders = {
	NAMESPACE: "cf-cache-namespace",
	STATUS: "cf-cache-status",
} as const;
